<ion-header id="header">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">Close<ion-icon slot="start" name="close-circle-outline"></ion-icon></ion-button>
    </ion-buttons>

    <ion-buttons slot="end">
      <ion-button (click)="save()"> Save<ion-icon slot="end" name="download-outline"></ion-icon> </ion-button>
    </ion-buttons>
    <ion-title>Amortization Report</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="light">
  @if (selectData$ | async; as data) {
    <ion-card class="ion-no-margin tw:m-4">
      <ion-card-header class="ion-text-uppercase tw:px-2 tw:py-2 tw:text-xs tw:font-bold tw:text-gray-500">
        Payment Summary
      </ion-card-header>
      <ion-card-content class="tw:px-2 tw:py-2">
        <ion-grid class="ion-no-padding">
          <ion-row>
            <ion-col size="12" size-md="5">
              <div class="tw:flex tw:items-center">
                <ion-icon
                  src="/assets/svg/monthly-payment.svg"
                  [ngClass]="['tw:text-5xl', 'tw:h-12', 'tw:w-12']"
                ></ion-icon>
                <div class="tw:ml-4">
                  <h2 class="tw:text-xs">You will have a monthly payment of:</h2>
                  <ion-text class="tw:text-base tw:font-bold tw:text-gray-800">
                    {{ data.monthlyPayment | redCurrency: 0 : 2 }}
                  </ion-text>
                </div>
              </div>
              <hr class="tw:my-3 tw:border-gray-300" />
            </ion-col>
            <ion-col size="12" size-md="7">
              <red-chart [options]="chartOptions"></red-chart>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-text class="tw:mt-4 tw:block tw:text-xs">
              Note: PMI taxes and insurance are NOT used in this calculation.
            </ion-text>
          </ion-row>
        </ion-grid>
      </ion-card-content>
    </ion-card>
    <ion-card class="ion-no-margin tw:m-4">
      <ion-card-header class="ion-text-uppercase tw:px-2 tw:py-2 tw:text-xs tw:font-bold tw:text-gray-500">
        Summary
      </ion-card-header>
      <ion-card-content class="tw:px-2 tw:py-2">
        <ion-grid class="ion-no-padding">
          <ion-row class="tw:bg-gray-100 tw:px-1 tw:py-0.5">
            <ion-col>
              <ion-text>Amount</ion-text>
            </ion-col>
            <ion-col class="tw:block tw:text-right">
              <ion-text>
                {{ data.principal | redCurrency: 0 : 2 }}
              </ion-text>
            </ion-col>
          </ion-row>
          <ion-row class="tw:px-1 tw:py-0.5">
            <ion-col>
              <ion-text>Interest Rate</ion-text>
            </ion-col>
            <ion-col class="tw:block tw:text-right">
              <ion-text>
                {{ data.interestRate | redPercentage: 0 }}
              </ion-text>
            </ion-col>
          </ion-row>
          <ion-row class="tw:bg-gray-100 tw:px-1 tw:py-0.5">
            <ion-col>
              <ion-text>Term</ion-text>
            </ion-col>
            <ion-col class="tw:block tw:text-right">
              <ion-text>
                {{ data.term | redTime: 'year' }}
              </ion-text>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-card-content>
    </ion-card>
    <ion-card class="ion-no-margin tw:m-4">
      <ion-card-header class="ion-text-uppercase tw:px-2 tw:py-2 tw:text-xs tw:font-bold tw:text-gray-500">
        Yearly Schedule
      </ion-card-header>
      <ion-card-content class="tw:px-2 tw:py-2">
        <div class="tw:overflow-x-auto">
          <div class="tw:mt-2 tw:flex tw:font-bold">
            <ion-text class="tw:block tw:w-32 tw:shrink-0 tw:bg-gray-300 tw:px-2 tw:py-1"> Payment # </ion-text>
            <ion-text class="tw:block tw:w-40 tw:shrink-0 tw:bg-gray-300 tw:px-2 tw:py-1"> Start Balance </ion-text>
            <ion-text class="tw:block tw:w-40 tw:shrink-0 tw:bg-gray-300 tw:px-2 tw:py-1"> Principal </ion-text>
            <ion-text class="tw:block tw:w-40 tw:shrink-0 tw:bg-gray-300 tw:px-2 tw:py-1"> Interest </ion-text>
            <ion-text class="tw:block tw:w-40 tw:shrink-0 tw:bg-gray-300 tw:px-2 tw:py-1"> End Balance </ion-text>
          </div>
          @for (scheduleEntry of data.amortizationAnnualSchedule; track scheduleEntry; let even = $even) {
            <div class="tw:flex">
              <ion-text class="tw:block tw:w-32 tw:shrink-0 tw:px-2 tw:py-1" [ngClass]="{ 'tw:bg-gray-100': even }">
                {{ scheduleEntry.paymentNumber }}
              </ion-text>
              <ion-text class="tw:block tw:w-40 tw:shrink-0 tw:px-2 tw:py-1" [ngClass]="{ 'tw:bg-gray-100': even }">
                {{ scheduleEntry.startBalance | redCurrency: 0 }}
              </ion-text>
              <ion-text class="tw:block tw:w-40 tw:shrink-0 tw:px-2 tw:py-1" [ngClass]="{ 'tw:bg-gray-100': even }">
                {{ scheduleEntry.principal | redCurrency: 0 }}
              </ion-text>
              <ion-text class="tw:block tw:w-40 tw:shrink-0 tw:px-2 tw:py-1" [ngClass]="{ 'tw:bg-gray-100': even }">
                {{ scheduleEntry.interest | redCurrency: 0 }}
              </ion-text>
              <ion-text class="tw:block tw:w-40 tw:shrink-0 tw:px-2 tw:py-1" [ngClass]="{ 'tw:bg-gray-100': even }">
                {{ scheduleEntry.endBalance | redCurrency: 0 }}
              </ion-text>
            </div>
          }
        </div>
      </ion-card-content>
    </ion-card>
    <ion-card class="ion-no-margin tw:m-4">
      <ion-card-header class="ion-text-uppercase tw:px-2 tw:py-2 tw:text-xs tw:font-bold tw:text-gray-500">
        Monthly Schedule
      </ion-card-header>
      <ion-card-content class="tw:px-2 tw:py-2">
        <div class="tw:overflow-x-auto">
          <div class="tw:mt-2 tw:flex tw:font-bold">
            <ion-text class="tw:block tw:w-32 tw:shrink-0 tw:bg-gray-300 tw:px-2 tw:py-1"> Payment # </ion-text>
            <ion-text class="tw:block tw:w-40 tw:shrink-0 tw:bg-gray-300 tw:px-2 tw:py-1"> Start Balance </ion-text>
            <ion-text class="tw:block tw:w-40 tw:shrink-0 tw:bg-gray-300 tw:px-2 tw:py-1"> Principal </ion-text>
            <ion-text class="tw:block tw:w-40 tw:shrink-0 tw:bg-gray-300 tw:px-2 tw:py-1"> Interest </ion-text>
            <ion-text class="tw:block tw:w-40 tw:shrink-0 tw:bg-gray-300 tw:px-2 tw:py-1"> End Balance </ion-text>
          </div>
          @for (scheduleEntry of data.amortizationMonthlySchedule; track scheduleEntry; let even = $even) {
            <div class="tw:flex">
              <ion-text class="tw:block tw:w-32 tw:shrink-0 tw:px-2 tw:py-1" [ngClass]="{ 'tw:bg-gray-100': even }">
                {{ scheduleEntry.paymentNumber }}
              </ion-text>
              <ion-text class="tw:block tw:w-40 tw:shrink-0 tw:px-2 tw:py-1" [ngClass]="{ 'tw:bg-gray-100': even }">
                {{ scheduleEntry.startBalance | redCurrency: 0 }}
              </ion-text>
              <ion-text class="tw:block tw:w-40 tw:shrink-0 tw:px-2 tw:py-1" [ngClass]="{ 'tw:bg-gray-100': even }">
                {{ scheduleEntry.principal | redCurrency: 0 }}
              </ion-text>
              <ion-text class="tw:block tw:w-40 tw:shrink-0 tw:px-2 tw:py-1" [ngClass]="{ 'tw:bg-gray-100': even }">
                {{ scheduleEntry.interest | redCurrency: 0 }}
              </ion-text>
              <ion-text class="tw:block tw:w-40 tw:shrink-0 tw:px-2 tw:py-1" [ngClass]="{ 'tw:bg-gray-100': even }">
                {{ scheduleEntry.endBalance | redCurrency: 0 }}
              </ion-text>
            </div>
          }
        </div>
      </ion-card-content>
    </ion-card>
  }
</ion-content>
